import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    addOrthodontistPractice,
    removeOrthodontistPractice
} from '../services/orthodontistAccounts';
import { ORTHODONTIST_DETAIL_KEY } from './queryKeys';

interface OrthodontistPracticeMutationInput {
    orthodontistId: string;
    practiceId: string;
}

// No separate list query to invalidate - the org's `practices` array already
// comes from useOrthodontistDetail, so a mutation just invalidates that.
export function useAddOrthodontistPractice() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ orthodontistId, practiceId }: OrthodontistPracticeMutationInput) =>
            addOrthodontistPractice(orthodontistId, practiceId),
        onSuccess: (_data, { orthodontistId }) => {
            queryClient.invalidateQueries({ queryKey: ORTHODONTIST_DETAIL_KEY(orthodontistId) });
        }
    });
}

export function useRemoveOrthodontistPractice() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ orthodontistId, practiceId }: OrthodontistPracticeMutationInput) =>
            removeOrthodontistPractice(orthodontistId, practiceId),
        onSuccess: (_data, { orthodontistId }) => {
            queryClient.invalidateQueries({ queryKey: ORTHODONTIST_DETAIL_KEY(orthodontistId) });
        }
    });
}
